module.exports = __webpack_public_path__ + "img/4_ua.935cdc66.jpg";